module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prize-manage"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    staticClass: "search-form",
    attrs: {
      "inline": true,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "奖品ID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ID精确搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.prizeId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "prizeId", $$v)
      },
      expression: "queryForm.prizeId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称模糊搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "prizeName", $$v)
      },
      expression: "queryForm.prizeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择奖品类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.prizeType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "prizeType", $$v)
      },
      expression: "queryForm.prizeType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "站内会员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "头像挂件",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "主题",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "电子证书",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "电子奖牌",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "实物奖励",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外链奖励",
      "value": 6
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.status),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "status", $$v)
      },
      expression: "queryForm.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "启用",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "停用",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.resetQuery
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增奖品")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "prizeId",
      "label": "奖品ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeType",
      "label": "奖品类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.prizeTypeText(row.prizeType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖品详情",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.detailType === 'text') ? _c('div', {
          staticClass: "detail-text"
        }, [_c('span', [_vm._v(_vm._s(row.detailContent))])]) : (row.detailType === 'image') ? _c('div', {
          staticClass: "detail-image"
        }, [_c('img', {
          staticClass: "detail-img",
          attrs: {
            "src": row.detailContent
          },
          on: {
            "click": function($event) {
              return _vm.previewImage(row.detailContent)
            }
          }
        })]) : (row.detailType === 'multiImage') ? _c('div', {
          staticClass: "detail-icons"
        }, _vm._l((row.detailContent), function(url, idx) {
          return _c('img', {
            key: idx,
            staticClass: "detail-icon-img",
            attrs: {
              "src": url
            },
            on: {
              "click": function($event) {
                return _vm.previewImage(url)
              }
            }
          })
        }), 0) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          class: row.status === 1 ? 'status-enabled' : 'status-disabled'
        }, [_vm._v("\n          " + _vm._s(row.status === 1 ? "启用" : "停用") + "\n        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (row.status === 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleChangeStatus(row, 0)
            }
          }
        }, [_vm._v("停用")]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleChangeStatus(row, 1)
            }
          }
        }, [_vm._v("启用")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.tableTotal
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增奖品",
      "size": "small",
      "modal-append-to-body": false
    },
    on: {
      "close": _vm.resetAddForm
    },
    model: {
      value: (_vm.addDialogVisible),
      callback: function($$v) {
        _vm.addDialogVisible = $$v
      },
      expression: "addDialogVisible"
    }
  }, [_c('el-form', {
    staticClass: "add-form",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "奖品名称"
    }
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请输入奖品名称，不超过20个字",
      "maxlength": 20,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "prizeName", $$v)
      },
      expression: "addForm.prizeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品类型"
    }
  }, [_c('el-select', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请选择奖品类型"
    },
    on: {
      "change": _vm.onPrizeTypeChange
    },
    model: {
      value: (_vm.addForm.prizeType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "prizeType", $$v)
      },
      expression: "addForm.prizeType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "站内会员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "头像挂件",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "主题",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "电子证书",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "电子奖牌",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "实物奖励",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外链奖励",
      "value": 6
    }
  })], 1)], 1), _vm._v(" "), (_vm.addForm.prizeType === 0) ? [_c('el-form-item', {
    attrs: {
      "label": "选择赠送卡"
    }
  }, [_c('el-select', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请选择赠送卡"
    },
    model: {
      value: (_vm.addForm.cardRefId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "cardRefId", $$v)
      },
      expression: "addForm.cardRefId"
    }
  }, _vm._l((_vm.privilegeConfigList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.addForm.prizeType === 1) ? [_c('el-form-item', {
    attrs: {
      "label": "奖品详情"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleSelectAvatar
    }
  }, [_vm._v("选择头像挂件")]), _vm._v(" "), (_vm.addForm.avatarUrl) ? _c('div', {
    staticClass: "selected-preview"
  }, [_c('img', {
    staticClass: "selected-img",
    attrs: {
      "src": _vm.addForm.avatarUrl
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selected-name"
  }, [_vm._v(_vm._s(_vm.addForm.avatarName))])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "type-warning"
  }, [_vm._v("\n            若在【个性化组件】中修改头像挂件，奖牌将被同步变更。\n          ")])])] : _vm._e(), _vm._v(" "), (_vm.addForm.prizeType === 2) ? [_c('el-form-item', {
    attrs: {
      "label": "奖品详情"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleSelectTheme
    }
  }, [_vm._v("选择主题")]), _vm._v(" "), (_vm.addForm.themeUrl) ? _c('div', {
    staticClass: "selected-preview"
  }, [_c('img', {
    staticClass: "selected-img",
    attrs: {
      "src": _vm.addForm.themeUrl
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selected-name"
  }, [_vm._v(_vm._s(_vm.addForm.themeName))])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "type-warning"
  }, [_vm._v("\n            若在【个性化组件】中修改主题，奖牌将被同步变更。\n          ")])])] : _vm._e(), _vm._v(" "), (_vm.addForm.prizeType === 3) ? [_c('el-form-item', [_c('div', {
    staticClass: "cert-tip"
  }, [_vm._v("\n            电子证书将使用系统默认模板，根据用户报名信息和完赛信息自动生成。\n          ")])])] : _vm._e(), _vm._v(" "), (_vm.addForm.prizeType === 4) ? [_c('el-form-item', {
    attrs: {
      "label": "奖品详情"
    }
  }, [_c('el-upload', {
    staticClass: "prize-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "auto-upload": false,
      "on-change": _vm.onMedalChange,
      "accept": "image/*"
    }
  }, [(_vm.addForm.medalUrl) ? _c('img', {
    staticClass: "prize-preview",
    attrs: {
      "src": _vm.addForm.medalUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus prize-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-tip"
  }, [_vm._v("\n            建议尺寸：200x200px，支持jpg/png格式，大小不超过2MB\n          ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.addForm.prizeType === 5) ? [_c('el-form-item', {
    attrs: {
      "label": "奖品详情"
    }
  }, [_c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.addForm.physicalUrl),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "physicalUrl", $$v)
      },
      expression: "addForm.physicalUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tip"
  }, [_vm._v("尺寸建议35*35，最大50KB，优先SVG其次png")])], 1)] : _vm._e(), _vm._v(" "), (_vm.addForm.prizeType === 6) ? [_c('el-form-item', {
    attrs: {
      "label": "奖励图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.addForm.prizeImage),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "prizeImage", $$v)
      },
      expression: "addForm.prizeImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tip"
  }, [_vm._v("尺寸建议35*35，最大50KB，优先SVG其次png")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "外链类型"
    }
  }, [_c('el-select', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请选择外链类型"
    },
    on: {
      "change": _vm.onOuterTypeChange
    },
    model: {
      value: (_vm.addForm.outerType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "outerType", $$v)
      },
      expression: "addForm.outerType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "微信小程序",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转URL",
      "value": 5
    }
  })], 1)], 1), _vm._v(" "), (_vm.addForm.outerType === 7) ? [_c('el-form-item', {
    attrs: {
      "label": "小程序原始ID"
    }
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请输入小程序原始ID"
    },
    model: {
      value: (_vm.addForm.appId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "appId", $$v)
      },
      expression: "addForm.appId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序路径"
    }
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请输入小程序路径，如 /pages/index"
    },
    model: {
      value: (_vm.addForm.path),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "path", $$v)
      },
      expression: "addForm.path"
    }
  })], 1)] : (_vm.addForm.outerType === 5) ? [_c('el-form-item', {
    attrs: {
      "label": "跳转URL"
    }
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请输入跳转URL"
    },
    model: {
      value: (_vm.addForm.outerUrl),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "outerUrl", $$v)
      },
      expression: "addForm.outerUrl"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.addForm.outerType) ? [_c('el-form-item', {
    attrs: {
      "label": "是否弹窗提示"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "isPopup", $$v)
      },
      expression: "addForm.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), (_vm.addForm.isPopup === 1) ? _c('el-form-item', {
    attrs: {
      "label": "弹窗内容"
    }
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请填写弹窗内容，最多20个字",
      "maxlength": 20,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addForm.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "popupContent", $$v)
      },
      expression: "addForm.popupContent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.isPopup === 1) ? _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label",
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/popup-prompt-example.png"),
      "alt": "弹窗示例"
    }
  })]) : _vm._e()] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    on: {
      "click": _vm.confirmAdd
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择头像挂件",
      "size": "small",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.avatarDialogVisible),
      callback: function($$v) {
        _vm.avatarDialogVisible = $$v
      },
      expression: "avatarDialogVisible"
    }
  }, [_c('div', {
    staticClass: "select-dialog-search"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "名称搜索",
      "clearable": "",
      "size": "small"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onAvatarSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.avatarSearchName),
      callback: function($$v) {
        _vm.avatarSearchName = $$v
      },
      expression: "avatarSearchName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.onAvatarSearch
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.avatarLoading),
      expression: "avatarLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.avatarList,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.onAvatarRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-radio', {
          attrs: {
            "label": row.id
          },
          model: {
            value: (_vm.selectedAvatarId),
            callback: function($$v) {
              _vm.selectedAvatarId = $$v
            },
            expression: "selectedAvatarId"
          }
        }, [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          staticClass: "select-list-img",
          attrs: {
            "src": row.url
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "select-dialog-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.avatarPageNum,
      "page-size": _vm.avatarPageSize,
      "total": _vm.avatarTotal,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.onAvatarPageChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.avatarDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmAvatar
    }
  }, [_vm._v("确 认")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择主题",
      "size": "small",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.themeDialogVisible),
      callback: function($$v) {
        _vm.themeDialogVisible = $$v
      },
      expression: "themeDialogVisible"
    }
  }, [_c('div', {
    staticClass: "select-dialog-search"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "名称搜索",
      "clearable": "",
      "size": "small"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onThemeSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.themeSearchName),
      callback: function($$v) {
        _vm.themeSearchName = $$v
      },
      expression: "themeSearchName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.onThemeSearch
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.themeLoading),
      expression: "themeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.themeList,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.onThemeRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-radio', {
          attrs: {
            "label": row.id
          },
          model: {
            value: (_vm.selectedThemeId),
            callback: function($$v) {
              _vm.selectedThemeId = $$v
            },
            expression: "selectedThemeId"
          }
        }, [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图像",
      "align": "center",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "theme-img-list"
        }, [_vm._l((row.homeIcon), function(icon, idx) {
          return [(icon.backToTop) ? _c('el-popover', {
            key: 'bt' + idx,
            attrs: {
              "placement": "right",
              "title": "大图浏览",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": icon.backToTop,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "select-list-img",
            attrs: {
              "slot": "reference",
              "src": icon.backToTop
            },
            slot: "reference"
          })]) : _vm._e(), _vm._v(" "), (icon.iconSelected) ? _c('el-popover', {
            key: 'is' + idx,
            attrs: {
              "placement": "right",
              "title": "大图浏览",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": icon.iconSelected,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "select-list-img",
            attrs: {
              "slot": "reference",
              "src": icon.iconSelected
            },
            slot: "reference"
          })]) : _vm._e(), _vm._v(" "), (icon.iconNormal) ? _c('el-popover', {
            key: 'in' + idx,
            attrs: {
              "placement": "right",
              "title": "大图浏览",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": icon.iconNormal,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "select-list-img",
            attrs: {
              "slot": "reference",
              "src": icon.iconNormal
            },
            slot: "reference"
          })]) : _vm._e()]
        }), _vm._v(" "), (row.homeIcon && row.homeIcon[0]) ? [(row.homeIcon[0].backgroundImage) ? _c('el-popover', {
          key: "bg",
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.homeIcon[0].backgroundImage,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "select-list-img",
          attrs: {
            "slot": "reference",
            "src": row.homeIcon[0].backgroundImage
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.homeIcon[0].homeBackgroundImage) ? _c('el-popover', {
          key: "homebg",
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.homeIcon[0].homeBackgroundImage,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "select-list-img",
          attrs: {
            "slot": "reference",
            "src": row.homeIcon[0].homeBackgroundImage
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.homeIcon[0].myBackgroundImage) ? _c('el-popover', {
          key: "mybg",
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.homeIcon[0].myBackgroundImage,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "select-list-img",
          attrs: {
            "slot": "reference",
            "src": row.homeIcon[0].myBackgroundImage
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.homeIcon[0].squareBackgroundUrl) ? _c('el-popover', {
          key: "sqbg",
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.homeIcon[0].squareBackgroundUrl,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "select-list-img",
          attrs: {
            "slot": "reference",
            "src": row.homeIcon[0].squareBackgroundUrl
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.homeIcon[0].sportBackgroundUrl) ? _c('el-popover', {
          key: "sportbg",
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.homeIcon[0].sportBackgroundUrl,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "select-list-img",
          attrs: {
            "slot": "reference",
            "src": row.homeIcon[0].sportBackgroundUrl
          },
          slot: "reference"
        })]) : _vm._e()] : _vm._e(), _vm._v(" "), (row.superscript) ? _c('el-popover', {
          key: "superscript",
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.superscript,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "select-list-img",
          attrs: {
            "slot": "reference",
            "src": row.superscript
          },
          slot: "reference"
        })]) : _vm._e()], 2)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "select-dialog-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.themePageNum,
      "page-size": _vm.themePageSize,
      "total": _vm.themeTotal,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.onThemePageChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.themeDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmTheme
    }
  }, [_vm._v("确 认")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pendingStatus === 0 ? '停用确认' : '启用确认',
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.disableDialogVisible),
      callback: function($$v) {
        _vm.disableDialogVisible = $$v
      },
      expression: "disableDialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.pendingStatus === 0 ?
    "确认停用该奖品？停用后该奖品将无法被赛事引用。" :
    "确认启用该奖品？"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.disableDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.disableLoading
    },
    on: {
      "click": _vm.confirmDisable
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片预览",
      "size": "small",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.previewVisible),
      callback: function($$v) {
        _vm.previewVisible = $$v
      },
      expression: "previewVisible"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.previewSrc
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "奖品详情",
      "size": "small",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.viewDialogVisible),
      callback: function($$v) {
        _vm.viewDialogVisible = $$v
      },
      expression: "viewDialogVisible"
    }
  }, [(_vm.currentRow) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.viewLoading),
      expression: "viewLoading"
    }],
    staticClass: "view-detail",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "view-row"
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("奖品ID：")]), _vm._v(_vm._s(_vm.currentRow.prizeId) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "view-row"
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("奖品名称：")]), _vm._v(_vm._s(_vm.currentRow.prizeName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "view-row"
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("奖品类型：")]), _vm._v(_vm._s(_vm.prizeTypeText(_vm.currentRow.prizeType)) + "\n      ")]), _vm._v(" "), (_vm.currentRow.prizeType !== 6) ? _c('div', {
    staticClass: "view-row"
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("奖品详情：")]), _vm._v(" "), (_vm.currentRow.detailType === 'text') ? _c('span', [_vm._v(_vm._s(_vm.currentRow.detailContent))]) : (_vm.currentRow.detailType === 'image') ? _c('img', {
    staticStyle: {
      "max-width": "200px",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.currentRow.detailContent
    }
  }) : (_vm.currentRow.detailType === 'multiImage') ? _c('span', {
    staticClass: "detail-icons"
  }, _vm._l((_vm.currentRow.detailContent), function(url, idx) {
    return _c('img', {
      key: idx,
      staticClass: "detail-icon-img",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": url
      },
      on: {
        "click": function($event) {
          return _vm.previewImage(url)
        }
      }
    })
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "view-row"
  }, [_c('div', {
    staticClass: "view-outer"
  }, [_c('div', [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("外链类型：")]), _vm._v(_vm._s(_vm.outerTypeText) + "\n          ")]), _vm._v(" "), (_vm.currentRow.detail) ? _c('div', [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("奖励图片：")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "200px",
      "max-height": "200px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.currentRow.detail
    },
    on: {
      "click": function($event) {
        return _vm.previewImage(_vm.currentRow.detail)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentRow.outerType === 7) ? [_c('div', [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("小程序原始ID：")]), _vm._v(_vm._s(_vm.parseOuterDetail(_vm.currentRow.outerUrl).appId) + "\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "wrap"
    }
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("小程序路径：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.parseOuterDetail(_vm.currentRow.outerUrl).path))])])] : (_vm.currentRow.outerType === 5) ? [_c('div', [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("跳转URL：")]), _vm._v(_vm._s(_vm.currentRow.outerUrl) + "\n            ")])] : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("是否弹窗提示：")]), _vm._v(_vm._s(_vm.currentRow.isPopup === 1 ? "是" : "否") + "\n          ")]), _vm._v(" "), (_vm.currentRow.isPopup === 1) ? _c('div', [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("弹窗内容：")]), _vm._v(_vm._s(_vm.currentRow.popupContent) + "\n          ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "view-row"
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("状态：")]), _vm._v(_vm._s(_vm.currentRow.status === 1 ? "启用" : "停用") + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "view-row"
  }, [_c('span', {
    staticClass: "view-label"
  }, [_vm._v("创建时间：")]), _vm._v(_vm._s(_vm.currentRow.createTime) + "\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header"
  }, [_c('h2', {
    staticClass: "page-header__title"
  }, [_vm._v("奖品管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76121274!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/matchPrizeManage.vue
// module id = 1078
// module chunks = 0